import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Gift, Check, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

interface WelcomeCreditsCardProps {
  creditsRemaining: number;
  creditsMonthly: number;
}

export function WelcomeCreditsCard({ creditsRemaining, creditsMonthly }: WelcomeCreditsCardProps) {
  const progressPercent = Math.min((creditsRemaining / creditsMonthly) * 100, 100);

  return (
    <div className="app-tile app-tile-hover p-6 relative overflow-hidden">
      {/* Subtle top accent line */}
      <div className="absolute inset-x-0 top-0 h-px bg-primary/30" />

      <div className="flex items-center gap-3 mb-1">
        <div className="app-icon-box">
          <Gift className="h-5 w-5" />
        </div>
        <div>
          <h3 className="app-section-title text-lg">Welcome credits</h3>
          <p className="text-sm text-muted-foreground">Your free credits to get started</p>
        </div>
      </div>

      <div className="mt-6 space-y-3">
        <div className="flex items-baseline justify-between">
          <span className="text-sm text-muted-foreground">Credits remaining</span>
          <span className="font-display text-3xl font-semibold tabular-nums tracking-tight text-foreground">
            {creditsRemaining}
          </span>
        </div>
        <Progress value={progressPercent} className="h-2" />
        <p className="text-xs text-muted-foreground text-center">
          {creditsRemaining} of {creditsMonthly} welcome credits
        </p>
      </div>

      <div className="my-5 grid grid-cols-2 gap-2 py-4 border-y border-border/60">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Check className="h-4 w-4 text-emerald-600 dark:text-emerald-400" />
          <span>Never expire</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Check className="h-4 w-4 text-emerald-600 dark:text-emerald-400" />
          <span>Use for any feature</span>
        </div>
      </div>

      <div className="space-y-3">
        <Button asChild className="w-full shadow-fluent-2" size="lg">
          <Link to="/plans" className="gap-2">
            Subscribe for more credits
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Button>
        <p className="text-xs text-center text-muted-foreground">
          Unlock Smart Categories, Smart Notes, monthly credit renewals, and more.
        </p>
      </div>
    </div>
  );
}
